import { useEffect, useState } from "react";
import { Row, Col, Spin, Checkbox } from 'antd';
import providerCodes from '../../../utils/providerCodes.json';
import { useTranslation } from 'react-i18next';

const LaboratoryExams = ({
  patientToAdmission,
  setPatientToAdmission,
  laboratoryPrestations,
  setLaboratoryPrestations,
  previousLaboratoryPrestations,
  loading,
  setPreviousLaboratoryPrestations,
  providerCode,
  laboratoryModule
}) => {
  const [fetchLoading, setFetchLoading] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    window.addEventListener('beforeunload', confirmRefreshPage);
    return () => {
      window.removeEventListener('beforeunload', confirmRefreshPage);
    };
  }, []);


  const confirmRefreshPage = (event) => {
    event.preventDefault();
    const message = "¿Estás seguro que deseas abandonar?";
    return (event.returnValue = message);
  };

  const handleLaborationSelection = (id) => {
    if (providerCodes[providerCode] !== 'bupa') {
      const _laboratoryPrestations = laboratoryPrestations.map((prestation, index) => {
        if (prestation.id === id && prestation.disabled === false) {
          prestation.selected = !prestation.selected;
        }
        return prestation;
      });
      setLaboratoryPrestations([..._laboratoryPrestations]);
      setPatientToAdmission({ ...patientToAdmission, laboratoryPrestations: laboratoryPrestations });
    }
  };




  return (

    <Row justify="center" className="laboratory-exams-step-2">
      <Col
        lg={22} xs={24}
        className="box pt-30 pb-30 pl-lg-70 pl-md-20 pl-sm-20 pl-xs-20 pr-lg-70 pr-md-20 pr-sm-20 pr-xs-20"
      >
        <Spin className="cmt-spin" spinning={fetchLoading || loading}>
          <Col lg={24} xs={24}>
            <h2 className='mb-20'>Selecciona los exámenes a enviar a laboratorio en línea</h2>
          </Col>
          <p className="text-title mb-20">
            {t('admissionPage.laboratoryExams.theServices')} tienen exámenes de laboratorio. Selecciona los exámenes que se enviarán <strong>a laboratorio en línea {providerCodes[providerCode]}.</strong>
          </p>
          <Row className="checkbox-prestations">
            <strong>
              Exámenes
            </strong>
          </Row>
          <Row>
            <Col xl={24} xs={24} className="prestation-col pt-20">
              {
                laboratoryPrestations?.map((prestation, index) => {
                  return (
                    <Row className="prestation-cell" key={index}>
                      <p>{prestation.name}</p>
                    </Row>
                  )
                })
              }
            </Col>
          </Row>
          {
            (patientToAdmission.admissionPatientId) &&
            <Row>
              <Col lg={24} xs={24} className="previousLaboratoryExams">
                <Row>
                  <strong>Exámenes ingresados para este {t('admissionPage.laboratoryExams.patient').toLocaleLowerCase()}</strong>
                  <Col xl={24} xs={24} className="previous-prestation-col">
                    {
                      previousLaboratoryPrestations?.map((prestation, index) => {
                        return (
                          <Row key={index}>
                            <strong>{prestation.name}</strong>
                          </Row>
                        )
                      })
                    }
                  </Col>
                </Row>
              </Col>
            </Row>
          }
        </Spin>
      </Col>
    </Row>

  );
};

export default LaboratoryExams;